import styled from 'styled-components'
import { Colors } from 'theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  line-height: 1.1;
`

export const TableWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  overflow-y: auto;
  min-height: 92vh;
  margin-bottom: 100px;

  table {
    width: 92%;
    border-collapse: collapse;
  }

  th,
  td {
    text-align: left;
    padding-left: 30px;
  }
`

export const ExecutedTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${Colors.black};
  text-align: left;
`

export const MainTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${Colors.black};
  text-transform: none;
`

export const Subtitle = styled.div<{ color: string }>`
  font-size: 12px;
  font-weight: 500;
  color: ${({ color }) => color};
  margin-top: 2px;
  text-transform: none;
`
export const ActivityContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 60px;
`

export const CustomText = styled.p`
  font-size: 14px;
  color: ${Colors.black};
  font-weight: 500;
  text-align: left;
  margin: 0;
`
